import React from "react";
import { Box } from "@mui/material";
import {
  PlayerCard,
  TeamCard,
  TeamVsTeamCard,
  ScoringSummaryCard,
} from "../../pages/Admin/SportsDataOverview";
import {
  sportsCardData,
  sportsCardVariant,
} from "../Chat/sportsCardModel";

const asObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value) ? value : {};

const SportsResponseCard = ({ payload, surface = "inline" }) => {
  if (!payload || typeof payload !== "object") return null;

  const data = sportsCardData(payload);
  const variant = sportsCardVariant(payload);
  const league = payload.league || data.league || {};
  const team =
    payload.selected_team ||
    payload.selectedTeam ||
    data.selected_team ||
    data.selectedTeam ||
    null;
  const player =
    payload.selected_player ||
    payload.selectedPlayer ||
    data.selected_player ||
    data.selectedPlayer ||
    null;
  if (!variant || !Object.keys(asObject(data)).length) return null;

  let card = null;
  if (variant === "player_card") {
    card = <PlayerCard player={player} card={data} team={team} />;
  } else if (variant === "team_card") {
    card = <TeamCard team={team} card={data} />;
  } else if (variant === "team_v_team") {
    card = <TeamVsTeamCard team={team} matchup={data} league={league} />;
  } else if (variant === "scoring_summary") {
    card = <ScoringSummaryCard summary={data} league={league} />;
  }

  if (!card) return null;

  return (
    <Box
      data-sports-response-card
      data-sports-card-variant={variant}
      data-sports-card-surface={surface}
      sx={{
        mt: surface === "inline" ? 2 : 0,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        "& > *": {
          width: "100%",
          boxSizing: "border-box",
        },
      }}
    >
      {card}
    </Box>
  );
};

export default SportsResponseCard;
